var url = "3c4e3c1c70a0f38eab2b056b519327d6.svg";
var cdnUrl = typeof _wml !== "undefined" && _wml.cdn && _wml.cdn.map(url);
module.exports = cdnUrl || __webpack_public_path__ + url;